/*
 * Footer Bracci: colunas em sanfona no celular.
 * O clique no título abre ou fecha a coluna. No desktop as colunas ficam sempre
 * abertas pelo CSS e o botão do título não faz nada.
 * Eventos delegados no document, então funcionam quando o editor recarrega a seção.
 */
(() => {
  if (window.BracciFooter) return;

  const MOBILE = window.matchMedia('(max-width: 749px)');

  document.addEventListener('click', (event) => {
    const toggle = event.target instanceof Element ? event.target.closest('[data-bf-toggle]') : null;
    if (!toggle) return;

    const footer = toggle.closest('[data-bf]');
    if (!footer || !footer.classList.contains('bf--accordion') || !MOBILE.matches) return;

    const column = toggle.closest('[data-bf-col]');
    if (!column) return;

    const open = !column.classList.contains('is-open');
    column.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
  });

  // No desktop o conteúdo fica sempre visível; aria-expanded acompanha.
  function syncExpanded() {
    document.querySelectorAll('[data-bf] [data-bf-toggle]').forEach((toggle) => {
      const column = toggle.closest('[data-bf-col]');
      const accordion = toggle.closest('[data-bf]')?.classList.contains('bf--accordion');
      const expanded = !MOBILE.matches || !accordion || Boolean(column?.classList.contains('is-open'));
      toggle.setAttribute('aria-expanded', String(expanded));
    });
  }

  MOBILE.addEventListener('change', syncExpanded);
  document.addEventListener('shopify:section:load', syncExpanded);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncExpanded);
  else syncExpanded();

  window.BracciFooter = { syncExpanded };
})();
